import request from "./services/axios.js";
// 邮件推送-获取任务列表
export function GetNetWorkArticles(params) {
  return request({
    params,
    url: "/vas/network/getNetworkArticles",
    method: "get"
  });
}
// 推送用户的来源分布
export function getSourceType(params) {
  return request({
    params,
    url: "/vas/send/author/getSourceType",
    method: "get"
  });
}
// 推送用户的机构分布
export function GetPushMagAuthorOrg(params) {
  return request({
    params,
    url: "/vas/send/author/getOrg",
    method: "get"
  });
}

// 推送用户的期刊分布
export function GetMag(params) {
  return request({
    params,
    url: "/vas/send/author/getMag",
    method: "get"
  });
}

// 阅读邮件用户的机构分布
export function GetOpenEmailOrg(params) {
  return request({
    params,
    url: "/vas/send/author/getOpenEmailOrg",
    method: "get"
  });
}

// 阅读邮件用户的期刊分布

export function GetOpenEmailMag(params) {
  return request({
    params,
    url: "/vas/send/author/getOpenEmailMag",
    method: "get"
  });
}

// 推送前后单篇文章阅读情况
export function GetVisitCount(params) {
  return request({
    params,
    url: "/vas/article/statistics/getVisitCount",
    method: "get"
  });
}

export function GetArticleInfo(params) {
  return request({
    params,
    url: "/vas/citAfterRead/articleInfo",
    method: "get"
  });
}

export function GetArticleInfoDetail(params) {
  return request({
    params,
    url: "/vas/article/getArticleInfo",
    method: "get"
  });
}

export function GetCitArticleInfo(params) {
  return request({
    params,
    url: "/vas/citAfterRead/citArticleInfo",
    method: "get"
  });
}

// 本年度文献关键词分布

export function GetKeywords(params) {
  return request({
    params,
    url: "/vas/push/task/pushTaskReport/yearKeywordsStatistic",
    method: "get"
  });
}

// 年度阅读量排行榜(引流)
export function GetArticleClickRankList(params) {
  return request({
    params,
    url: "/vas/article/statistics/articleLogClickRankList",
    method: "get"
  });
}

// 传播路径分析-年度

export function GetYearDiffusePath(params) {
  return request({
    params,
    url: "/vas/push/task/annualReport/terrain/analysis",
    method: "get"
  });
}


// 近五期传播前后官网访问量

export function GetWebsiteVisit(params) {
  return request({
    params,
    url: "/vas/push/task/pushTaskReport/websiteVisit",
    method: "get"
  });
}


export function GetJournalPage(params) {
  return request({
    params,
    url: "/vas/networkjournal/journalPage",
    method: "get"
  });
}